import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import { MdDashboard } from 'react-icons/md';
import { Modal, Button } from 'react-bootstrap';
import images from '@assets';
import onboardingStore from '../../stores/onboardingStore';
import OnboardingService from '../../services/onboarding.service';
import './OnboardingSidebar.scss';

@inject('commonStore')
@withRouter
@observer
export default class OnboardingSidebar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showExitConfirmation: false
        };
    }

    handleHomeClick = (e) => {
        e.preventDefault();
        // Show confirmation dialog
        this.setState({ showExitConfirmation: true });
    };

    handleCancelExit = () => {
        this.setState({ showExitConfirmation: false });
    };

    handleConfirmExit = async () => {
        const { commonStore, history } = this.props;

        try {
            // Close the modal first
            this.setState({ showExitConfirmation: false });

            // Show loading
            commonStore.setLoading(true);

            // Get all saved onboarding data (completed steps only)
            const onboardingData = onboardingStore.getOnboardingData();

            const profileId = commonStore.businessProfile?.id;

            // Complete onboarding with whatever data has been saved
            const result = await OnboardingService.completeOnboarding(onboardingData, profileId);

            if (result.success) {
                // Update business profile if needed
                if (result.profileId && !profileId) {
                    await commonStore.getBusinessProfile(result.profileId);
                }

                // Clear onboarding data from storage
                onboardingStore.clearOnCompletion();

                // Show success message
                commonStore.setMsg('Your progress has been saved. You can continue onboarding anytime.');

                // Navigate to home
                history.push('/home');
            }
        } catch (error) {
            console.error('Error completing onboarding:', error);

            // Even if there's an error, allow navigation (non-blocking)
            commonStore.setMsg('Your progress has been saved locally.');

            // Navigate to home anyway
            history.push('/home');
        } finally {
            commonStore.setLoading(false);
        }
    };

    render() {
        const { user } = this.props.commonStore;
        const { showExitConfirmation } = this.state;

        return (
            <>
                <nav className="onboarding-sidebar">
                    {/* Top Section - Logo and Home Button */}
                    <div className="sidebar-top">
                        <div className="logo-container">
                            <img
                                className="logo-image"
                                src={images.NisaFinLogoTransparent}
                                alt="Nisa Finance Logo"
                            />
                        </div>

                        <div className="home-link-container">
                            <a href="#" onClick={this.handleHomeClick} className="home-link">
                                <MdDashboard size="18" className="icon-home" />
                                <span className="link-text">Home</span>
                            </a>
                        </div>
                    </div>

                    {/* Bottom Section - User Profile */}
                    <div className="sidebar-bottom">
                        <div className="user-profile">
                            <div className="avatar-circle">
                                {user && user.email ? user.email.charAt(0).toUpperCase() : 'U'}
                            </div>
                            <div className="user-email">
                                {user && user.email ? user.email : 'user@example.com'}
                            </div>
                        </div>
                    </div>
                </nav>

                {/* Exit Confirmation Modal */}
                <Modal show={showExitConfirmation} onHide={this.handleCancelExit} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Exit Onboarding?</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>Are you sure you want to exit onboarding? Your progress will be saved.</p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.handleCancelExit}>
                            Cancel
                        </Button>
                        <Button variant="primary" onClick={this.handleConfirmExit}>
                            Confirm
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}
